import { Country, IpInfo } from "@/data/country";

export const getCountry = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = (await response.json()) as IpInfo;
    const userIP = data.ip;

    const countryResponse = await fetch(`https://ipapi.co/${userIP}/country/`);

    return (await countryResponse.text()) as Country;
  } catch (err) {
    console.error("Error fetching user country:", err);
    return undefined;
  }
};
